import axios from 'axios'

import type {
  FetchWorkoutParams,
  RawFetchWorkoutResponse,
  Workout,
} from './types'
import { formatDate } from 'ui-component-library/utils/helpers'
import parse from './parse'
import errorLogging from 'services/error-logging'

const PREVIEW_WODS_URL = process.env.PREVIEW_WODS_URL
const WODS_URL = process.env.WODS_URL
const URL_DATE_FORMAT = 'yyyy/MM/dd'

export function fetchWorkout(
  params: FetchWorkoutParams,
): Promise<Workout | null> {
  const { date, isPreview } = params

  const baseUrl = isPreview ? PREVIEW_WODS_URL : WODS_URL

  return axios
    .get<RawFetchWorkoutResponse>(
      `${baseUrl}/${formatDate(date, URL_DATE_FORMAT)}`,
    )
    .then((response) => {
      if (response.data.wods) {
        return parse(response.data.wods)
      } else {
        throw new Error('workout response invalid')
      }
    })
    .catch((error) => {
      errorLogging(new Error('error fetching workout'), {
        error,
        params,
      })
      return null
    })
}
